import React, { useEffect } from "react";
import get from "lodash/get";
import throttle from "lodash/throttle";
import { object, number, string, any } from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import YouTube from "react-youtube";
import getYouTubeID from "get-youtube-id";
import { STORY_HEADER_IN_VIEW } from "../../store/actions";

import { StoryElement } from "@quintype/components";

import "./video-story-header.m.css";

const YoutubePlayer = ({ element, index }) => {
  const options = {
    playerVars: {
      autoplay: 1,
      mute: 1,
      muted: 1,
      playsinline: 1,
      controls: 1,
    },
  };

  const onReady = (e) => {
    e.target.playVideo();
  };

  const onError = (error) => {
    console.error("YouTube player error:", error);
  };

  return <YouTube videoId={getYouTubeID(element.url)} opts={options} onReady={onReady} onError={onError} />;
};

YoutubePlayer.propTypes = {
  element: object,
  index: number,
};

const VideoStoryHeader = ({ story, primaryVideo, publisherName, videoRef }) => {
  const dispatch = useDispatch();
  const qtStates = useSelector((state) => state);
  const storyHeaderInView = get(qtStates, "storyHeaderInView", true);

  const handleScroll = () => {
    const storyHeaderPosition = videoRef.current.getBoundingClientRect();
    if (storyHeaderPosition.top < 75 && storyHeaderInView) {
      dispatch({
        type: STORY_HEADER_IN_VIEW,
        payload: false,
      });
    } else if (storyHeaderPosition.top > 75 && !storyHeaderInView) {
      dispatch({
        type: STORY_HEADER_IN_VIEW,
        payload: true,
      });
    }
  };

  const throttledHandleScroll = throttle(handleScroll, 200);

  useEffect(() => {
    window.addEventListener("scroll", throttledHandleScroll);
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
      throttledHandleScroll.cancel();
    };
  }, [throttledHandleScroll]);

  let renderTemplates = {};

  if (primaryVideo?.type === "youtube-video") {
    renderTemplates = { "youtube-video": YoutubePlayer };
  }

  return (
    <div styleName="story-video" id="sticky-video" ref={videoRef}>
      {primaryVideo && (
        <StoryElement
          element={primaryVideo}
          story={story}
          publisherName={publisherName}
          renderTemplates={renderTemplates}
        />
      )}
    </div>
  );
};

VideoStoryHeader.propTypes = {
  story: object.isRequired,
  primaryVideo: object,
  publisherName: string,
  videoRef: any,
};

export default VideoStoryHeader;
